// export const BaseUrl = 'http://localhost:5001';
export const BaseUrl = 'https://api.tenderskiosk.com';
